import { EvmAddress } from '~/utils/address'

export enum VestingProtocol {
  SablierV3 = 'sablierV3',
  SablierV2 = 'sablierV2',
  Hedgey = 'hedgey',
  HedgeyTokenLockup = 'hedgeyTokenLockup',
}

export type VestingBalance = {
  id: string
  smartAccountId: string
  accountAddress: EvmAddress.Type
  chainId: number
  contractAddress: EvmAddress.Type
  tokenId: bigint
  tokenAddress: EvmAddress.Type
  claimableAmount: bigint
  protocol: VestingProtocol
  streamURL: string
  claimFee:
    | {
        amount: bigint
        tokenAddress: EvmAddress.Type
      }
    | undefined
  cliffTime: number | undefined
}

export type VestingBalancesResponse = Omit<
  VestingBalance,
  'tokenId' | 'claimableAmount' | 'claimFee' | 'cliffTime'
> & {
  tokenId: string
  claimableAmount: string
  claimFee:
    | {
        amount: string
        tokenAddress: EvmAddress.Type
      }
    | undefined
  cliffTime: number | undefined
}

export type VestingDetailsResponse = {
  details: {
    tokenAddress: EvmAddress.Type
    totalAmount: string
    vestedAmount: string
    claimedAmount: string
    claimableAmount: string
    startTime: number
    endTime: number
    cliffTime: number | undefined
    shape: 'Linear' | 'Dynamic' | 'Tranched'
    isCancelable: boolean
  }
}

export type VestingDetails = {
  tokenAddress: EvmAddress.Type
  totalAmount: bigint
  vestedAmount: bigint
  claimedAmount: bigint
  claimableAmount: bigint
  startTime: number
  endTime: number
  cliffTime: number | undefined
  shape: 'Linear' | 'Dynamic' | 'Tranched'
  isCancelable: boolean
}
